import { Grid } from '@mui/material';
import { HSpacer, VSpacer } from '@nx-smartmonkey/ui';

import ErrorIcon from '../../../../../../assets/img/data-importer/icon-error.svg';
import InfoIcon from '../../../../../../assets/img/data-importer/icon-info.svg';
import SuccessIcon from '../../../../../../assets/img/data-importer/icon-success.svg';
import WarningIcon from '../../../../../../assets/img/data-importer/icon-warning.svg';
import Button from '../../../../../../react-components/Button';
import Text from '../../../../../../react-components/Text';
import { FieldMapping } from '../fields/FieldMapping';

const ICON_SIZE = 18;

interface MapFieldsColumnSummaryProps {
  columnIndex: number;
  mapping: FieldMapping;
  setMapping: (mapping: FieldMapping) => void;
}

export const MapFieldsColumnSummary = ({ columnIndex, mapping, setMapping }: MapFieldsColumnSummaryProps) => {
  const mappingItem = mapping.getByColumnIndex(columnIndex);

  const validValues = mappingItem?.valid ?? 0;
  const errors = mappingItem?.errors ?? 0;
  const emptyValues = mappingItem?.empty ?? 0;
  const values = validValues + errors + emptyValues;

  return (
    <Grid
      container
      direction="column"
      style={{
        position: `relative`,
        padding:
          mappingItem?.field.id.includes(`address.`) && !mapping.hasValidAddress() && !(values >= 2) ? `0px` : `10px 0`,
      }}
    >
      {!mappingItem ? (
        <Grid item container direction="row" alignItems="center">
          <img src={InfoIcon} alt="Info" width={ICON_SIZE} height={ICON_SIZE} />
          <HSpacer small />
          <Text variant="label" intlId="plans.dialogs.upload_stops.map_fields.column_not_mapped" />
        </Grid>
      ) : (
        <>
          <Grid style={{ display: `flex` }}>
            <Grid item container direction="row" alignItems="center" style={{ width: `auto` }}>
              <img src={SuccessIcon} alt="Success" width={ICON_SIZE} height={ICON_SIZE} />
              <HSpacer small />
              <Text intlId="plans.dialogs.upload_stops.map_fields.valid_values" intlValues={{ valid: validValues }} />
            </Grid>

            <HSpacer small />

            {errors > 0 && (
              <>
                <Grid item container direction="row" alignItems="center" style={{ width: `auto` }}>
                  <img src={ErrorIcon} alt="Error" width={ICON_SIZE} height={ICON_SIZE} />
                  <HSpacer small />
                  <Text intlId="plans.dialogs.upload_stops.map_fields.invalid_values" intlValues={{ errors }} />
                </Grid>

                <HSpacer small />
              </>
            )}

            {emptyValues > 0 && (
              <>
                <Grid item container direction="row" alignItems="center" style={{ width: `auto` }}>
                  <img src={WarningIcon} alt="Warning" width={ICON_SIZE} height={ICON_SIZE} />
                  <HSpacer small />
                  <Text
                    intlId="plans.dialogs.upload_stops.map_fields.empty_values"
                    intlValues={{ empty: emptyValues }}
                  />
                </Grid>
                <HSpacer small />
              </>
            )}
          </Grid>
          {values >= 2 && <VSpacer medium />}
          {values >= 3 && <VSpacer large />}
          {mappingItem.field.id.includes(`address.`) && !mapping.hasValidAddress() && (
            <Grid item container direction="row" alignItems="center" style={{ width: `auto` }}>
              <div style={{ width: `${ICON_SIZE}px` }} />
              <HSpacer small />
              <Text intlId="plans.dialogs.upload_stops.map_fields.invalid_address_fields" />
            </Grid>
          )}

          <Grid item style={{ position: `absolute`, bottom: 0 }}>
            <Button
              variant="flat"
              styleType="secondary"
              style={{
                padding: `7px 12px`,
                margin:
                  mappingItem?.field.id.includes(`address.`) && !mapping.hasValidAddress() && !(values >= 2)
                    ? `0px`
                    : undefined,
              }}
              onClick={() => {
                setMapping(mapping.removeByColumn(columnIndex));
              }}
            >
              <Text style={{ cursor: `pointer` }} intlId="plans.dialogs.upload_stops.map_fields.unassign_column" />
            </Button>
          </Grid>
        </>
      )}
    </Grid>
  );
};
